<template>
  <div class="__common-layout-pageTabs" v-if="cpyId!=201">

    <div class="__tabs" id="nav">
      <div class="__tab-item" v-for="item in openedPageRouters" :class="{
            '__is-active': item.fullPath == $route.fullPath,
          }" :key="item.fullPath" @click="onClick(item)" @contextmenu.prevent="showContextMenu($event, item)">
        {{ item.meta.title }}
        <span class="el-icon-close" @click.stop="onClose(item)" @contextmenu.prevent.stop=""
          :style="(item.fullPath=='/welcome'&&openedPageRouters.length==1) ? 'width:0;' : ''"></span>
      </div>
    </div>
    <div>
      <el-button size="mini" type="primary" @click="closeOther">关闭其他</el-button>
    </div>

    <!-- <div v-show="contextMenuVisible">
      <ul :style="{ left: contextMenuLeft + 'px', top: contextMenuTop + 'px' }" class="__contextmenu">
        <li>
          <el-button type="text" @click="reload()" size="mini">
            重新加载
          </el-button>
        </li>
        <li>
          <el-button type="text" @click="closeOtherLeft" :disabled="false" size="mini">关闭左边</el-button>
        </li>
        <li>
          <el-button type="text" @click="closeOtherRight" :disabled="false" size="mini">关闭右边</el-button>
        </li>
        <li>
          <el-button type="text" @click="closeOther" size="mini">关闭其他</el-button>
        </li>
      </ul>
    </div> -->
  </div>
</template>
<script>
  import {
    mapMutations,mapState
  } from 'vuex'
  export default {
    props: {
      keepAliveComponentInstance: {}, //keep-alive控件实例对象
      blankRouteName: {
        type: String,
        default: "blank",
      }, //空白路由的name值
    },
    data() {
      return {
        contextMenuVisible: false, //右键菜单是否显示
        contextMenuLeft: 0, //右键菜单显示位置
        contextMenuTop: 0, //右键菜单显示位置
        contextMenuTargetPageRoute: null, //右键所指向的菜单路由
        // openedPageRouters: [], //已打开的路由页面
        cpyId:''
      };
    },
    watch: {
      //当路由变更时，执行打开页面的方法
      $route: {
        handler(v) {

          this.openPage(v);
        },
        immediate: true,
      },
      '$store.state.deleterouter'() {
        this.onClose(this.deleterouter)
      }
    },
    mounted() {
      let userAccount=JSON.parse(window.sessionStorage.getItem('userAccount'))
      this.cpyId=userAccount.cpyId
      //添加点击关闭右键菜单
      window.addEventListener("click", this.closeContextMenu);
      this.scrollInit();
    },
    computed: {
      ...mapState(['openedPageRouters','deleterouter'])
    },
    destroyed() {
      window.removeEventListener("click", this.closeContextMenu);
    },
    deactivated() {
      window.removeEventListener("click", this.closeContextMenu);
    },

    methods: {
      ...mapMutations(['setopenedPageRouters']),
      // 初始化与绑定监听事件方法
      scrollInit() {
        // 获取要绑定事件的元素
        const nav = document.getElementById("nav")
        var flag; // 鼠标按下
        var downX; // 鼠标点击的x下标
        var scrollLeft; // 当前元素滚动条的偏移量
        nav.addEventListener("mousedown", function(event) {
          flag = true;
          downX = event.clientX; // 获取到点击的x下标
          scrollLeft = this.scrollLeft; // 获取当前元素滚动条的偏移量
        });
        nav.addEventListener("mousemove", function(event) {
          if (flag) { // 判断是否是鼠标按下滚动元素区域
            var moveX = event.clientX; // 获取移动的x轴
            var scrollX = moveX - downX; // 当前移动的x轴下标减去刚点击下去的x轴下标得到鼠标滑动距离
            this.scrollLeft = scrollLeft - scrollX // 鼠标按下的滚动条偏移量减去当前鼠标的滑动距离

          }
        });
        // 鼠标抬起停止拖动
        nav.addEventListener("mouseup", function() {
          flag = false;
        });
        // 鼠标离开元素停止拖动
        nav.addEventListener("mouseleave", function(event) {
          flag = false;
        });
      },
      //打开页面
      openPage(route) {

        if (route.name == this.blankRouteName) {
          return;
        }

        let isExist = this.openedPageRouters.some(
          (item) => item.fullPath == route.fullPath
        );

        this.setopenedPageRouters(this.openedPageRouters)
        if (!isExist) {
          let openedPageRoute = this.openedPageRouters.find(
            (item) => item.path == route.path
          );
          this.setopenedPageRouters(this.openedPageRouters)
          //判断页面是否支持不同参数多开页面功能，如果不支持且已存在path值一样的页面路由，那就替换它
          if (!route.meta.canMultipleOpen && openedPageRoute != null) {
            this.delRouteCache(openedPageRoute.fullPath);
            this.openedPageRouters.splice(
              this.openedPageRouters.indexOf(openedPageRoute),
              1,
              route
            );
            this.setopenedPageRouters(this.openedPageRouters)
          } else {

            this.openedPageRouters.push(route);
            this.setopenedPageRouters(this.openedPageRouters)
          }
        }
      },
      //点击页面标签卡时
      onClick(route) {

        if (route.fullPath !== this.$route.fullPath) {
          route.meta.norefresh = true
          this.$router.push(route.fullPath);
        }
      },
      //关闭页面标签时
      onClose(route) {

        let index = this.openedPageRouters.indexOf(route);
        this.setopenedPageRouters(this.openedPageRouters)
        this.delPageRoute(route);
        if (route.fullPath === this.$route.fullPath) {
          //删除页面后，跳转到上一页面
          this.$router.replace(
            this.openedPageRouters[index == 0 ? 0 : index - 1]
          );
          this.setopenedPageRouters(this.openedPageRouters)
        }
        if(this.openedPageRouters.length==0){
          this.$router.push('/welcome')
        }
      },
      //右键显示菜单
      showContextMenu(e, route) {
        this.contextMenuTargetPageRoute = route;
        this.contextMenuLeft = e.layerX;
        this.contextMenuTop = e.layerY;
        this.contextMenuVisible = true;
      },
      //隐藏右键菜单
      closeContextMenu() {
        this.contextMenuVisible = false;
        this.contextMenuTargetPageRoute = null;
      },
      //重载页面
      reload() {
        this.delRouteCache(this.contextMenuTargetPageRoute.fullPath);
        if (this.contextMenuTargetPageRoute.fullPath === this.$route.fullPath) {
          this.$router.replace({
            name: this.blankRouteName
          }).then(() => {
            this.$router.replace(this.contextMenuTargetPageRoute);
          });
        }
      },
      //关闭其他页面
      async closeOther() {
        // 弹框询问用户是否删除
        const confirmResult = await this.$confirm('是否关闭其他页面？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).catch(err => err)
        // 如果用户确认删除,则返回值为字符串 confirm
        // 如果用户取消删除,则返回值为字符串 cancel
        //
        if (confirmResult !== 'confirm') {
          return this.$message.info('已经取消删除')
        }
        for (let key in this.openedPageRouters) {
          if (this.openedPageRouters[key].fullPath === this.$route.fullPath) {
            this.contextMenuTargetPageRoute = this.openedPageRouters[key]
            break
          }
        }
        for (let i = 0; i < this.openedPageRouters.length; i++) {
          let r = this.openedPageRouters[i];
          if (r !== this.contextMenuTargetPageRoute) {
            this.delPageRoute(r);
            i--;
          }
        }
        this.setopenedPageRouters(this.openedPageRouters)
        if (this.contextMenuTargetPageRoute.fullPath != this.$route.fullPath) {
          this.$router.replace(this.contextMenuTargetPageRoute);
        }
      },
      //根据路径获取索引
      getPageRouteIndex(fullPath) {
        for (let i = 0; i < this.openedPageRouters.length; i++) {
          if (this.openedPageRouters[i].fullPath === fullPath) {
            return i;
          }
        }
      },
      //关闭左边页面
      closeOtherLeft() {
        let index = this.openedPageRouters.indexOf(
          this.contextMenuTargetPageRoute
        );
        let currentIndex = this.getPageRouteIndex(this.$route.fullPath);
        if (index > currentIndex) {
          this.$router.replace(this.contextMenuTargetPageRoute);
        }
        for (let i = 0; i < index; i++) {
          let r = this.openedPageRouters[i];
          this.delPageRoute(r);
          i--;
          index--;
        }
        this.setopenedPageRouters(this.openedPageRouters)
      },
      //关闭右边页面
      closeOtherRight() {
        let index = this.openedPageRouters.indexOf(
          this.contextMenuTargetPageRoute
        );
        let currentIndex = this.getPageRouteIndex(this.$route.fullPath);
        for (let i = index + 1; i < this.openedPageRouters.length; i++) {
          let r = this.openedPageRouters[i];
          this.delPageRoute(r);
          i--;
        }
        if (index < currentIndex) {
          this.$router.replace(this.contextMenuTargetPageRoute);
        }
        this.setopenedPageRouters(this.openedPageRouters)
      },
      //删除页面
      delPageRoute(route) {
        let routeIndex = this.openedPageRouters.indexOf(route);
        if (routeIndex >= 0) {
          this.openedPageRouters.splice(routeIndex, 1);
        }
        this.setopenedPageRouters(this.openedPageRouters)
        this.delRouteCache(route.fullPath);
      },
      //删除页面缓存
      delRouteCache(key) {
        let cache = this.keepAliveComponentInstance.cache;
        let keys = this.keepAliveComponentInstance.keys;

        for (let i = 0; i < keys.length; i++) {
          if (keys[i] == key) {

            cache[keys[i]].componentInstance.$destroy()
            keys.splice(i, 1);
            if (cache[key] != null) {
              delete cache[key];
            }
            break;
          }
        }
      },
    },
  };
</script>
<style lang="less" scoped>
  .__common-layout-pageTabs {
    display: flex;
    justify-content: space-between;

    .__contextmenu {
      // width: 100px;
      margin: 0;
      border: 1px solid #e4e7ed;
      background: #fff;
      z-index: 3000;
      position: absolute;
      list-style-type: none;
      padding: 5px 0;
      border-radius: 4px;
      font-size: 14px;
      color: #333;
      box-shadow: 1px 1px 3px 0 rgba(0, 0, 0, 0.1);

      li {
        margin: 0;
        padding: 0px 15px;

        &:hover {
          background: #f2f2f2;
          cursor: pointer;
        }

        button {
          color: #2c3e50;
        }
      }
    }

    position: relative;

    // ::before {
    //   content: "";
    //   border-bottom: 1px solid #dcdfe6;
    //   position: absolute;
    //   left: 0;
    //   right: 0;
    //   bottom: 0;
    //   height: 100%;
    // }

    .__tabs {
      display: flex;

      .__tab-item {
        white-space: nowrap;
        padding: 7px 12px;
        font-size: 12px;
        color: #999999;
        line-height: 14px;
        cursor: pointer;
        transition: color 0.3s cubic-bezier(0.645, 0.045, 0.355, 1),
        padding 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
        background-color: #ffffff;
        // margin-right: 10px;
        margin: 0 10px 10px 0;
        border-radius: 3px;

        &:first-child {
          border-left: 1px solid #dcdfe6;
          border-top-left-radius: 2px;
          // margin-left: 10px;
        }

        &:last-child {
          border-top-right-radius: 2px;
          // margin-right: 10px;
        }

        &:not(.__is-active):hover {
          color: var(--primary, #1A7BFC);

          .el-icon-close {
            width: 15px;
            margin-right: 0px;
            line-height: 15px;
            text-align: center;
          }
        }

        &.__is-active {
          padding-right: 12px;
          border: 1px solid var(--primary, #1A7BFC);
          color: var(--primary, #1A7BFC);

          .el-icon-close {
            width: 15px;
            height: 15px;
            margin-right: 0px;
            // margin-left: 2px;
            line-height: 15px;
            text-align: center;
          }
        }

        .el-icon-close {
          width: 0px;
          height: 15px;
          line-height: 15px;
          text-align: center;
          overflow: hidden;
          border-radius: 50%;
          font-size: 12px;
          margin-right: 12px;
          transform-origin: 100% 50%;
          transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
          vertical-align: text-top;

          &:hover {
            background-color: rgba(26, 123, 252, 0.2);
            color: var(--primary, #1A7BFC);
          }
        }
      }
    }
  }

  #nav {
    width: 90%;
    overflow-x: auto;
    overflow-y: hidden;
  }

  #nav::-webkit-scrollbar {
    width: 0 !important;
    height: 0px !important;
  }

  /* ===== 步骤 9：Mobile 页签栏精简 ===== */
  html[data-bp='mobile'] #nav {
    width: 72%;
  }

  html[data-bp='mobile'] .__common-layout-pageTabs .el-button {
    padding: 5px 8px;
    font-size: 12px;
  }
</style>
